<div class="flex flex-col gap-4" [formGroup]="form()">
  <h5 class="x-font-body-3 mt-2 text-[var(--tui-text-primary)]">
    {{ 'request_create.section_vehicle' | translate }}
  </h5>

  <div class="flex flex-col gap-1">
    <tui-textfield
      tuiChevron
      [stringify]="stringifyCarBrand"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <label tuiLabel>
        {{ 'request_create.car_brand' | translate }}
      </label>

      <input tuiSelect formControlName="carBrandId" />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (brand of carBrands(); track brand.id) {
            <button tuiOption type="button" [value]="brand.id">
              {{ brand.name }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.car_model' | translate }}</label>
      <input tuiInput formControlName="carModel" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.car_vin' | translate }}</label>
      <input tuiInput formControlName="carVin" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.car_plant_number' | translate
      }}</label>
      <input tuiInput formControlName="carPlantNumber" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.car_year' | translate }}</label>
      <input tuiInput inputmode="numeric" formControlName="carYear" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield
      [tuiNumberFormat]="{ precision: 0 }"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <label tuiLabel>
        {{ 'request_create.area_code' | translate }}
      </label>

      <input tuiInputNumber formControlName="areaCode" />
    </tui-textfield>
  </div>

  <h5 class="x-font-body-3 mt-2 text-[var(--tui-text-primary)]">
    {{ 'request_create.section_delivery' | translate }}
  </h5>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.delivery_name' | translate }}</label>
      <input tuiInput formControlName="deliveryName" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.delivery_address' | translate
      }}</label>
      <input tuiInput formControlName="deliveryAddress" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.delivery_person_name' | translate
      }}</label>
      <input tuiInput formControlName="deliveryPersonName" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.delivery_person_phone' | translate
      }}</label>
      <input tuiInput formControlName="deliveryPersonPhone" />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.delivery_person_email' | translate
      }}</label>
      <input tuiInput type="email" formControlName="deliveryPersonEmail" />
    </tui-textfield>
  </div>

  <h5 class="x-font-body-3 mt-2 text-[var(--tui-text-primary)]">
    {{ 'request_create.section_release' | translate }}
  </h5>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>
        {{ 'request_create.release_date' | translate }}
      </label>

      <input tuiInputDate formControlName="releaseDate" />
      <tui-calendar *tuiDropdown />
    </tui-textfield>
  </div>

  <div class="flex flex-col gap-1">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>
        {{ 'request_create.release_time' | translate }}
      </label>

      <input tuiInputTime formControlName="releaseTime" />
    </tui-textfield>
  </div>
</div>
